<template>
  <div class="row">
    <div class="col-sm-6">
      <card class="stacked-form">
        <cause-form
          @submit="submit"
          :init-cause="{ direction: 1, has_price: 0 }"
          :val-errors="valErrors"
          submit-text="Erstellen"
        />
      </card>
    </div>
  </div>
</template>

<script>
import CauseForm from './cause-form'

export default {
  components: { CauseForm },
  data () {
    return {
      valErrors: []
    }
  },
  methods: {
    async submit (cause) {
      await this.initCsrf()

      this.valErrors = []
      this.$http.post('causes', cause).then(({ data }) => {
        this.$notify({
          message: 'Grund erfolgreich erstellt.',
          type: 'success'
        })
        this.$router.push('/causes')
      }).catch(({ response }) => { this.valErrors = response.data.errors })
    }
  }
}
</script>

<style>
</style>
